import { FieldProps } from '@sitecore-jss/sitecore-jss-react-forms';
import classNames from 'classnames/bind';
import styles from '../JssNextForm.module.scss';

const cx = classNames.bind(styles);

export const RichTextField = (props: FieldProps) => {
  const { field } = props;
  const fieldContent = field.model['text'] || '';
  const cssClass = (field.model['cssClass'] || '').toString();

  if (!fieldContent) {
    return null;
  }

  return (
    <div className={cx('sc-form-richtext', cssClass)}>
      <div dangerouslySetInnerHTML={{ __html: `${fieldContent}` }} />
    </div>
  );
};
